import { type DatasourceCellValue } from '../content-column-read.ts';

/** A ready issue may have no data for the selected column. */
export type JiraIssueColumnValue = { readonly value: DatasourceCellValue | undefined };
export type JiraIssueDetailsReadContent = {
  readonly kind: 'jira-issue-details';
  readonly isPriority: boolean;
  readonly items: readonly {
    readonly key: string;
    readonly column: JiraIssueColumnValue;
  }[];
};
export const EMPTY_JIRA_ISSUE_DETAILS_CONTENT: JiraIssueDetailsReadContent =
  Object.freeze({
    kind: 'jira-issue-details',
    isPriority: false,
    items: Object.freeze([])
  });
